import React from "react";
import "./MensHealthPage.css";

const MensHealthPage = () => {
  const handleCallClick = () => {
    window.location.href = "tel:+917007512120";
  };

  const handleWhatsAppClick = () => {
    window.location.href = "https://wa.me/919118063939";
  };

  const handleEmailClick = () => {
    window.location.href = "mailto:info@swasthmitra.com";
  };

  return (
    <>
      <div className="mensHealthSection">
        <h2>💪 Take Charge of Your Health – Men's Health Essentials at SwasthMitra</h2>
        <div className="mensHealthContent">
          <p>
            Your health is your strength. At <strong>SwasthMitra</strong>, we understand that men face unique health challenges — and we're here to help you address them <strong>confidentially, affordably, and effectively</strong>.
          </p>
          <p>
            Whether you're looking to improve your vitality, support your fitness, or manage personal health concerns — we offer a curated range of <strong>trusted men's health products and solutions</strong>, delivered discreetly to your doorstep.
          </p>

          <hr />

          <h3>🔹 What We Offer in Men's Health</h3>

          <div className="healthCategory">
            <h4>🧠 Stress, Sleep & Mental Wellness</h4>
            <ul>
              <li>Herbal stress-relief capsules</li>
              <li>Melatonin & natural sleep aids</li>
              <li>Brain supplements and multivitamins</li>
            </ul>
            <div className="categoryNote">
              <p>For mental clarity, better sleep, and improved focus</p>
            </div>
          </div>

          <div className="healthCategory">
            <h4>🏋 Performance & Stamina</h4>
            <ul>
              <li>Ayurvedic and allopathic sexual wellness supplements</li>
              <li>Energy boosters and testosterone support</li>
              <li>Delayed climax sprays and performance enhancers</li>
            </ul>
            <div className="categoryNote">
              <p>Discreetly packaged. Trusted brands only.</p>
            </div>
          </div>

          <div className="healthCategory">
            <h4>❤ Heart & Vital Organ Support</h4>
            <ul>
              <li>Omega-3 & CoQ10 supplements</li>
              <li>BP monitors and heart care kits</li>
              <li>Liver detox and prostate health products</li>
            </ul>
          </div>

          <div className="healthCategory">
            <h4>💊 Daily Wellness & Immunity</h4>
            <ul>
              <li>Men's multivitamins</li>
              <li>Hair, skin, and beard care supplements</li>
              <li>Joint care, bone strength & digestion support</li>
            </ul>
            <div className="categoryNote">
              <p>Because real strength is built from the inside out.</p>
            </div>
          </div>

          <div className="healthCategory">
            <h4>🧼 Men's Personal Hygiene & Grooming</h4>
            <ul>
              <li>Intimate washes & hygiene kits</li>
              <li>Anti-fungal creams, powders, and soaps</li>
              <li>Hair fall solutions & skincare essentials</li>
            </ul>
          </div>

          <hr />

          <h3>🔒 Discreet. Safe. Reliable.</h3>
          <div className="benefits">
            <p>✅ Your products are <strong>packed discreetly</strong></p>
            <p>✅ We sell only <strong>genuine, doctor-recommended brands</strong></p>
            <p>✅ Your data and privacy are always <strong>protected</strong></p>
            <p>✅ We offer <strong>support</strong>, not judgment</p>
          </div>

          <hr />

          <div className="shopSection">
            <h3>🛒 Shop with Confidence</h3>
            <p>
              From fitness-focused to wellness-oriented — your health goals matter. And we're here to support every step.
            </p>
            <div className="buttonsContainer">
              
              <button className="whatsappButton" onClick={handleWhatsAppClick}>💬 WhatsApp Us</button>
              <button className="callButton" onClick={handleCallClick}>📞 Call Us</button>
            </div>
          </div>

          <hr />

          <div className="didYouKnow">
            <h3>🧠 Did You Know?</h3>
            <div className="facts">
              <p>• 7 out of 10 men delay seeking help for health issues</p>
              <p>• Early care = faster recovery & better results</p>
              <p>• Taking charge of your health starts with one small step</p>
            </div>
          </div>

          <div className="closingSection">
            <h3>🙌 Be the Healthiest Version of You — with SwasthMitra</h3>
            <p>
              No taboos. No judgment. Just trusted care.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default MensHealthPage;